import script from "./ConfigDispenser.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigDispenser.vue?vue&type=script&setup=true&lang=js"

import "./ConfigDispenser.vue?vue&type=style&index=0&id=a57fb334&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a57fb334"]])

export default __exports__